import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpenQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOpenQuote2"><Path d="M13.5 19.5H21.5V11.5L17.5 11.5V4.5C17.5 4.5 13.5 6.10714 13.5 10.9286V19.5Z" stroke="currentColor"/><Path d="M2.5 19.5H10.5L10.5 11.5L6.5 11.5L6.5 4.5C6.5 4.5 2.5 6.10714 2.5 10.9286L2.5 19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconOpenQuote2;
